module.exports = __webpack_public_path__ + "components/homepage-hero/static/hero-bg-580-1a27b3180aea111562b4d6f52679309c.webp";